import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const CustomerCtx = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, object=signed in

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setCustomer(false);
      return;
    }
    api.get("/account/me").then((r) => setCustomer(r.data)).catch(() => setCustomer(false));
  }, []);

  const value = useMemo(() => {
    const logout = async () => {
      try { await api.post("/account/logout"); } catch (e) { console.error(e); }
      setCustomer(false);
    };
    return { customer, setCustomer, logout };
  }, [customer]);

  return <CustomerCtx.Provider value={value}>{children}</CustomerCtx.Provider>;
};

export const useCustomer = () => useContext(CustomerCtx);
